import React, { useState } from 'react';

const Accordion = ({ title, children, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`accordion${open ? ' open' : ''}`}>
      <button
        className="accordion-header"
        onClick={() => setOpen(prev => !prev)}
      >
        <span>{title}</span>
        <span className="accordion-chevron">{open ? '▲' : '▼'}</span>
      </button>
      <div className="accordion-content" style={{ display: open ? undefined : 'none' }}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
